import { useNavigate, Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { routes } from '@/lib/routes';

interface PageHeaderProps {
  title?: string;
  showBack?: boolean;
  right?: ReactNode;
  /** Show the Teamity logo + wordmark instead of a text title */
  showBrand?: boolean;
}

export function PageHeader({ title, showBack, right, showBrand }: PageHeaderProps) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-background/90 backdrop-blur-sm border-b border-border">
      <div className="flex items-center h-14 px-4 max-w-lg mx-auto gap-2">
        {showBack && (
          <button
            onClick={() => navigate(-1)}
            className="p-1.5 -ml-1.5 rounded-lg hover:bg-muted transition-colors text-muted-foreground"
            aria-label="Zurück"
          >
            <ChevronLeft size={22} />
          </button>
        )}

        {showBrand ? (
          <Link
            to={routes.app.hub()}
            aria-label="Zur App-Übersicht"
            className="flex items-center gap-2 flex-1 -ml-1 rounded-lg p-1 hover:bg-muted transition-colors"
          >
            <img src="/logo-wordmark.png" alt="" className="w-10 h-10 object-contain" />
            <span
              style={{ fontFamily: 'var(--font-serif)', letterSpacing: '0.03em' }}
              className="text-xl font-medium text-foreground leading-none"
            >
              Teamity
            </span>
          </Link>
        ) : (
          <h1 className="flex-1 text-base font-semibold font-sans truncate">{title}</h1>
        )}

        {right && <div className="flex-shrink-0">{right}</div>}
      </div>
    </header>
  );
}
